import React, { Fragment } from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { IconButton } from '@mui/material';
import MoreIcon from '@mui/icons-material/MoreVert';
import Popover from '@mui/material/Popover';

const PREFIX = 'DropDownMenu';

const classes = {
  menu: `${PREFIX}-menu`,
};

const StyledPopover = styled(Popover)(({ theme }) => ({
  [`& .${classes.menu}`]: {
    '& .MuiMenuItem-root': {
      marginTop: '4px',
      marginBottom: '4px',
    },
  },
}));

const DropDownMenu = props => {
  const { size, ...rest } = props;

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMenuOpen = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(undefined);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <IconButton {...rest} onClick={handleMenuOpen} size={size ? size : 'small'}>
        <MoreIcon />
      </IconButton>
      <StyledPopover
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        classes={{ paper: classes.menu }}
        onClose={handleMenuClose}
        onClick={handleMenuClose}
        open={open}
        anchorEl={anchorEl}
      >
        {props.children}
      </StyledPopover>
    </>
  );
};

DropDownMenu.propTypes = {
  className: PropTypes.string,
};

export default DropDownMenu;
